<script setup>
import { computed, ref } from 'vue';
import { isEmpty } from 'lodash';
import { useSeleccionMultiple } from '@/composables/useSeleccionMultiple';
import InputCheckboxBoolean from '../cifra/InputCheckboxBoolean.vue';

const props = defineProps({
  inputName: { type: String, default: null },
  grupos: { type: Array, required: true },
  titulo: { type: String, default: null },
});

const seleccionadosIds = ref([]);

const idsSeleccionables = computed(
  () => props.grupos.map((grupo) => grupo.id),
);

const { establecerValor } = useSeleccionMultiple(seleccionadosIds, idsSeleccionables);
</script>

<template>
  <table v-if="!isEmpty(grupos)" class="table table-bordered">
    <thead v-if="titulo">
      <tr>
        <th class="col-min">
          <BotonSeleccionarTodo
            v-model="seleccionadosIds"
            :valores="idsSeleccionables"
          />
        </th>
        <th>{{ titulo }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="grupo in grupos" :key="grupo.id">
        <td class="col-min text-center">
          <InputCheckboxBoolean
            :model-value="seleccionadosIds.includes(grupo.id)"
            :input-id="`check-${grupo.id}`"
            :value="grupo.id"
            :name="inputName"
            class="m-r-none"
            @update:model-value="establecerValor(grupo.id, $event)"
          />
        </td>
        <td>
          <label :for="`check-${grupo.id}`" class="clickable">
            {{ grupo.etiqueta || grupo.nombre }}
          </label>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
.m-r-none {
  margin-right: 0 !important;
}
</style>
